import { useQuery } from 'react-apollo'
import { GetPackage } from '../../../graphql/packages/queries'
import { Package } from '@labsavvyapp/components'

/**
 *  Query to get a package by id

 * @returns Package
 */

interface GetPackageVariables {
  id: string
}

export const useQueryGetPackageApi = (variables: GetPackageVariables) => {
  const { id } = variables

  const {
    data: getPackageData,
    error: getPackageError,
    loading: getPackageLoading,
    refetch: refetchGetPackageData,
  } = useQuery(GetPackage, {
    variables: {
      id: id,
    },
    skip: !id,
  })

  return {
    data: getPackageData?.getPackage as Package,
    error: getPackageError,
    loading: getPackageLoading,
    refetch: refetchGetPackageData,
  }
}
